import { render } from "./NewsletterLayout.vue?vue&type=template&id=055917b1"
const script = {}

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__